import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Cut } from "../../types/student-info/studentInfoCutsShema"; // Замените на ваш тип данных

interface CutState {
    items: Cut[] | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: CutState = {
    items: null,
    isLoading: true,
    error: null,
};

const cutsSlice = createSlice({
    name: "cuts",
    initialState,
    reducers: {
        setCutData: (state, action: PayloadAction<Cut[] | null>) => {
            state.items = action.payload;
            state.isLoading = false;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
    },
});

export const { setCutData, setLoading, setError } = cutsSlice.actions;

export const cutsReducer = cutsSlice.reducer;